<template>
  <div id="extra-component-form-wizard-demo">
    <vs-row vs-type="flex" vs-justify="center" class="mt-8">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-md="10"
        vs-lg="10"
        vs-sm="12"
      >
        <form-wizard-icon-tab></form-wizard-icon-tab>
      </vs-col>
    </vs-row>

    <vs-row vs-type="flex" vs-justify="center" class="mt-8">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-md="10"
        vs-lg="10"
        vs-sm="12"
      >
        <!--          target="_blank"-->
        <a href="https://maylink.io/" target="_blank"
          ><img
            src="new_logo.png"
            alt="Logo"
            style="max-width: 120px; position:relative"
        /></a>
      </vs-col>
    </vs-row>

    <footer class="the-footer flex-wrap justify-center">
      <p></p>
      <span class="md:flex items-center">
        <span class="sm:inline-block"
          >&copy; {{ new Date().getFullYear() }} De idea a realidad por
          &nbsp;</span
        >
        <a href="https://mayfer.dev/" target="_blank" rel="nofollow">MAYFER</a>
      </span>
    </footer>

    <!-- <the-footer /> -->
    <!-- <footer class="the-footer flex-wrap justify-center" >
        <img src="http://dashboard.maylink.io/wp-content/uploads/2021/08/logo.png" alt="Logo" style="max-width: 120px; margin-top: 15px; right: 20px; position:relative">
        <h1>MAYLINK</h1>
    </footer>   -->
  </div>
</template>

<script>
import FormWizardIconTab from "./FormWizardIconTab-fie.vue";
export default {
  components: {
    FormWizardIconTab,
  },
};
</script>
